/* src/app/components/licenses-components/licenses-license-dashboard/licenses-license-dashboard.component.scss */
:host > div {
  display: flex;
  flex-direction: row;
}
:host > div > app-companies-company-image-card {
  flex-basis: 50%;
}
/*# sourceMappingURL=licenses-license-dashboard.component.css.map */
